import React, { useCallback, useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { Button, Modal, ModalBody, ModalHeader } from 'reactstrap'

interface RouterPromptProps {
    when: boolean
    title: string
    description: string[]
    onOk: () => any
    okText: string
    onCancel: () => any
    cancelText: string
    otherOkText?: string
    otherOnOk?: () => any
    whitelist: string[]
    hideOk?: boolean | undefined
}

export const RouterPrompt: React.FC<RouterPromptProps> = (props) => {
    const { when, onOk, onCancel, otherOnOk, title, description, okText, cancelText, otherOkText, whitelist, hideOk } = props
    const history = useHistory();

    const [showPrompt, setShowPrompt] = useState(false);
    const [currentPath, setCurrentPath] = useState("");

    useEffect(() => {
        if (when) {
            history.block((prompt) => {
                if (!whitelist.includes(prompt.pathname)) {
                    setCurrentPath(prompt.pathname);
                    setShowPrompt(true);
                    return 'true'
                }
            });
        } else {
            history.block(() => { });
        }

        return () => {
            history.block(() => { });
        };
    }, [history, when]);

    const handleOk = useCallback(async () => {
        if (onOk) {
            const canRoute = await Promise.resolve(onOk());
            if (canRoute) {
                history.block(() => { });
                history.push(currentPath);
            }
        }
    }, [currentPath, history, onOk]);

    const handleOtherOk = useCallback(async () => {
        if (otherOnOk) {
            const canRoute = await Promise.resolve(otherOnOk());
            if (canRoute) {
                history.block(() => { });
                history.push(currentPath);
            }
        }
    }, [currentPath, history, otherOnOk]);

    const handleCancel = useCallback(async () => {
        if (onCancel) {
            const canRoute = await Promise.resolve(onCancel());
            if (canRoute) {
                history.block(() => { });
                history.push(currentPath);
            }
        }
        setShowPrompt(false);
    }, [currentPath, history, onCancel]);

    return (
        <Modal isOpen={showPrompt}>
            <ModalHeader className='bg-primary text-light m-0'>{title}</ModalHeader>
            <ModalBody>
                <div className='row'>
                    <div className='col-12 text-center'>{description.map((item, i) => (<div key={i}>{item}</div>))}</div>
                    <div className='col-12 text-center mt-3'>
                        {!hideOk && <Button color='danger' onClick={handleOk}>{okText}</Button>}
                        {otherOkText && otherOnOk && <Button color='gray' className='ml-3' onClick={handleOtherOk}>{otherOkText}</Button>}
                        <Button color='success' className='ml-3' onClick={handleCancel}>{cancelText}</Button>
                    </div>
                </div>
            </ModalBody>
        </Modal>
    );
}